import { type } from '../utils/assist'
import camelcase from 'camelcase-web'

// 字典缓存对象
const Cache = {}

//
function eopt(option) {
    if (typeof option == "object") {
        return Object.assign({}, option)
    }
    
    return option
}

// 词典对象
function Dict(options) {
    this.init(options)
}

Object.assign(Dict.prototype, {
    init(options = {}) {
        this.options = Object.assign({}, Dict.options, options)
        
        var { name, pid, list } = this.options
        // private
        this._list = list ? list.map(v => Object.assign({}, v, {
            id: v.id,
            text: v.text,
            // 记录原始值，追踪变化
            originText: v.text,
            changed: false
        })) : []
        this._map = this._list.reduce((acc, v) => {
            acc[v.id] = v
            
            return acc
        }, {})
        
        this._groupName = name
        this._pid = pid
        // 记录创建时间
        this._createdTime = (new Date()).getTime()
    },
    
    val(key, value) {
        // val() 返回option列表
        if (arguments.length <= 0) {
            return this._list.map(v => eopt(v))
        }
        
        if (arguments.length >= 1) {
            // val(key) 返回单个option
            if (typeof value == "undefined") {
                var opt = this.get(key)
                
                return opt ? opt.text : void(0)
            } else {
                // val(key, value) 
                var opt = this.get(key)
                
                // 修改
                if (opt) {
                    opt.text = value
                    if (opt.originText) {
                        opt.changed = opt.originText != value
                    }
                }
                // 新增
                else {
                    opt = { id: key, text: value, originText: null, changed: true }
                    
                    this._list.push(opt)
                    this._map[key] = opt
                }
                
                return this
            }
        }
    },
    
    get(key) {
        return eopt(this._map[key])
    },
    
    // alias to val()
    toList() {
        return this.val()
    },
    
    find(key) {
        if (typeof key == "function") {
            return eopt(this._list.find(key))
        } else {
            return eopt(this._list.find(item => item.id == key))
        }
    },
    
    findAll(predicate) {
        return this._list.filter(predicate).map(v => eopt(v))
    },
    
    keyOf(text) {
        var target = this.find(v => v.text == text)
        
        return target ? target.id : null
    },
    
    // 更新后台词典
    update() {
        return Promise.all(this._list
            .filter(v => v.changed)
            .map(v => this.options.saveDict(this._pid, v.text)))
    },
})

// static
// 选项
Dict.options = {
    // 查询词典
    /**  
        return: Array<DictGroup>
        
        DictGroup: {
            name: String 词典名称（code）,
            pid: String 分类id,
            list: Array<DictItem> 词典项
        }
        
        DictItem: {
            id: String 唯一标识,
            text: String 值,
            remark: String 备注
        }
    */
    getDict(config) {
        return []
    },
    // 更新词典
    saveDict(pid, text) {
        return Promise.resolve()
    },
}

// 获取字典数据
Dict.viewDict = function(config) {
    var data = this.options.getDict(config)
    
    return Promise.resolve(data)
}
// 获取词典对象
Dict.get = function(dictName, sync) {
    var result = {},
        isSingle = false,
        config
    
    // 同步标识
    if (type(sync) == "undefined") {
        sync = false
    }
    
    // config模式
    if (type(dictName) == "object") {
        var config = dictName
        
        dictName = config.code
    }
    
    // dictName
    if (type(dictName) == "string") {
        dictName = [dictName]
        isSingle = true
    }
    
    if (type(dictName) == "array") {
        var groups = [],
            strangers = []
        
        dictName.forEach(name => {
            if (Cache[name] && sync == false) {
                groups.push(Cache[name])
            } else {
                strangers.push(name)
            }
        })
        
        if (strangers.length > 0) {
            var query = Dict.viewDict(Object.assign({}, config, { code: strangers.join(",") }))
            
            // 缓存
            strangers.forEach(k => {
                Cache[k] = query.then(res => {
                    var dict = res.find(v => v.name == k)
                    
                    return dict ? new Dict(dict) : null
                })
                
                groups.push(Cache[k])
            })
        }
        
        return Promise.all(groups)
            .then(dictGroup => {
                dictGroup.forEach(v => {
                    result[v._groupName] = v
                    
                    // 驼峰命名词典
                    var camel = camelcase(v._groupName)
                    if (camel != v._groupName) {
                        result[camel] = v
                        Cache[camel] = Promise.resolve(v)
                    }
                })
                
                if (isSingle) {
                    result = result[dictName[0]]
                }
                
                return result
            })
    }
    
    return Promise.resolve(result)
}

// 全局更新
Dict.update = function(dictName) {
    // update all 
    if (type(dictName) == "undefined") {
        dictName = Object.keys(Cache)
    }
    
    // spec dict
    if (type(dictName) == "string") {
        dictName = [dictName]
    }
    
    // batch update
    if (type(dictName) == "array") {
        var task = dictName.reduce((acc, name) => {
            if (Cache[name]) {
                acc.push(Cache[name].update())
            }
            
            return acc
        }, [])
        
        return Promise.all(task)
    }
    
    return Promise.resolve()
}
// NULL模式
Dict.NULL = new Dict()

// Dict Manager
export default Dict